:host {
  --RadialProgress__medium_width: 165px;
  --RadialProgress__medium_height: 140px;
  --RadialProgress__small_width: 110px;
  --RadialProgress__small_height: 93px;
  --RadialProgress__title--color: var(--theme-primary-text);
  --RadialProgress__title--font-size: 30px;
  --RadialProgress__title--font-weight: 400;
  --RadialProgress__subtitle--font-size: 12px;
  --RadialProgress__subtitle--color: var(--aha-gray-600);
  --RadialProgress__subtitle--text-transform: uppercase;

  display: block;
  position: relative;
  width: var(--RadialProgress__medium_width);
  height: var(--RadialProgress__medium_height);
}

:host([size='small']) {
  --RadialProgress__title--font-size: 24px;
  --RadialProgress__subtitle--font-size: 11px;

  width: var(--RadialProgress__small_width);
  height: var(--RadialProgress__small_height);
}

slot::slotted(aha-radial-progress-line) {
  position: absolute;
}

#label {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
#title {
  font-size: var(--RadialProgress__title--font-size);
  color: var(--RadialProgress__title--color);
}

#subtitle {
  font-size: var(--RadialProgress__subtitle--font-size);
  color: var(--RadialProgress__subtitle--color);
  text-transform: var(--RadialProgress__subtitle--text-transform);
}
